class AboutPagesGoogleMaps {
    constructor() {
        let $ = jQuery;
        let self = this;

        $('.mm__about-map').each(function() {
            return self.initMapOSM( $(this) );
        });


        // $('.mm__about-map').each(function() {
        //     return self.initMap( $(this) );
        // });


        $('#about-store .directions, #about-us .directions').click(function() {
            self.getDirections($(this));
        });
    }

    /**
	 * initMap
	 *
	 * Renders a Google Map onto the selected jQuery element
	 *
	 * @param   jQuery $el The jQuery element.
	 * @return  object The map instance.
	 */
    initMap( $el ) {
        let $ = jQuery;
        let center, icon;

        // Find marker elements within map.
        let $markers = $el.find('.marker');

        // Get data attributes from each marker
        $markers.each(function() {
            center = {
                lat: parseFloat( $(this).data('lat') ),
                lng: parseFloat( $(this).data('lng') ),
            };
            icon = $(this).data('icon');
        });

        // Removes points of intrest from the map
        let removeDefaultLabels = [
            {
                featureType: "poi",
                elementType: "labels",
                stylers: [
                        { visibility: "off" }
                ]
            }
        ];

        // Create generic map.
        let mapArgs = {
            zoom        : 16,
            center: center,
            mapTypeId   : google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            zoomControl: false,
            styles: removeDefaultLabels,
        };

        let map = new google.maps.Map( $el[0], mapArgs);
        let marker = new google.maps.Marker({
            position: center,
            icon: icon,
            map: map
        });

        // Return map instance
        return map;
    }


    initMapOSM($el){
        let $ = jQuery;

        if($el.length == 0)
            return;

        console.log("INIT MAP OSM");
        console.log($el);
        
        /* Responsive map */
        
        
        var markers =$el.find('.marker');

        let center = [];

        for (var i = 0; i < markers.length; i++) {            
            center = [$(markers[i]).data('lat'), $(markers[i]).data('lng')];
        }
        var map = L.map($el[0]).setView([center[0], center[1]], 6);

        console.log(markers);

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 15,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(map);

        L.Marker.prototype.options.icon = L.icon({
            iconUrl: "/wp-content/themes/nordsjo-theme/resources/dist/images/map-pin.png",
            iconSize: [40, 40],
            iconAnchor: [20, 40],
        });
        
        if(markers.length > 0) {
            for (var i = 0; i < markers.length; i++) {
                map.addLayer(L.marker([
                    $(markers[i]).data('lat'), $(markers[i]).data('lng')
                ]));
            }
        }

        return map;
    }

    getDirections($el) {
        let $ = jQuery;
        let destination,
            destinationLat, 
            destinationLng,
            origin,
            originLat,
            originLng,
            url;


        destinationLat = parseFloat( $el.data('lat') );
        destinationLng = parseFloat( $el.data('lng') );
        destination = `${destinationLat},${destinationLng}`;

        // Get current position
        // Try HTML5 geolocation.
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {

                originLat = position.coords.latitude;
                originLng = position.coords.longitude;
                origin = `${originLat},${originLng}`;

                url = `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}&travelmode=driving`;
                window.open(url);
                return false;

            }, function () {
                alert("Error: The Geolocation service failed.");
                return;
            });
        } else {
            // Browser doesn't support Geolocation
            alert("Error: Your browser doesn't support geolocation.");
            return;
        }
    }
}

export default AboutPagesGoogleMaps;